import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/omt-ams/licenses/$licenseId/deregister")(
  {
    beforeLoad: ({ params }) => {
      throw redirect({
        to: "/omt-ams/licenses/$licenseId/view",
        params: { licenseId: params.licenseId },
      });
    },
    component: () => null,
  },
);
